import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';
import { useGutterResult, usePaddingResult, useSizeResult } from '../../utils';

type GridProps = PropsWithChildren<{ width: number }>;

export function Grid({ children, width }: GridProps) {
  const { items } = useSettings();
  const gutterResult = useGutterResult(width);
  const maxLogoSize = items.reduce(
    (max, { size }) => (max > size ? max : size),
    0
  );

  const paddingResult = usePaddingResult(width);
  const sizeResult = useSizeResult(width, true, maxLogoSize);
  const finalSizeResult = sizeResult + 2 * paddingResult;

  return (
    <Container
      _maxSize={finalSizeResult > 100 ? finalSizeResult : undefined}
      _gutter={gutterResult}
    >
      {children}
    </Container>
  );
}

const Container = styled.div.attrs({
  className: `${meta.prefix}-grid-container`
})`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & .${meta.prefix}-logo-component {
    ${({ _maxSize }) => _maxSize && `width: ${_maxSize}px !important;`}
  }

  margin-bottom: -${({ _gutter }) => Math.trunc(_gutter * 0.75)}px;
`;
